import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0f37fa9d&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=0f37fa9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37fa9d",
  null
  
)

export default component.exports